import script from "./menuBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__